import React from 'react';
import { Layout } from 'antd';

import './style.scss';

export function Home() {
  return (
    <Layout className="pd-cms-home main-container">
      <div className="container">
        <div className="content">
          <div className="center-object">
            <div className="image">
              <img
                src={`/img/logo/homestory.png`}
                width="450"
                alt="logo homestory"
              />
            </div>
            <div className="homeTitle">Administrator Page</div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default { Home };
